import { Action, createReducer, on } from '@ngrx/store';
import * as fromCurrentFactSheetActions from '../actions';
import { ICurrentFasheet } from '../models/current-factsheet.model';

export const getCurrentFactsheetFeatureKey = 'getCurrentFactsheet';

export interface State {
  loaded: boolean;
  error?: Error | any;
  getCurrentFactSheet: ICurrentFasheet;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  getCurrentFactSheet: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromCurrentFactSheetActions.loadGetCurrentFactsheets,

    state => state
  ),
  on(fromCurrentFactSheetActions.loadGetCurrentFactsheetsSuccess, (state, action) => ({
    ...state,
    getCurrentFactSheet: action.response,
    loaded: true
  })),

  on(fromCurrentFactSheetActions.loadGetCurrentFactsheetsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectCurrentFactSheets = (state: State) => state.getCurrentFactSheet;
export const selectCurrentFactSheetsLoaded = (state: State) => state.loaded;
export const selectCurrentFactSheetsError = (state: State) => state.error;
